import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-m-success-animation-component",
	templateUrl: "./success-animation.component.html",
	styleUrls: ["./success-animation.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SuccessAnimationComponent {}
